import { render, staticRenderFns } from "./ProfilePitch.vue?vue&type=template&id=47a79ea4"
import script from "./ProfilePitch.vue?vue&type=script&lang=js"
export * from "./ProfilePitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports